import { getBackendUrl } from '../config';

function forceDownload(blobUrl, filename) {
  var a = document.createElement('a');
  a.download = filename;
  a.href = blobUrl;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revogar na hora cancela o download no Chrome; sem revogar nunca, o blob de
  // um áudio ou vídeo longo fica retido na aba até o reload.
  window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
}

export function downloadResource(url, filename) {
  const backendBaseUrl = getBackendUrl()?.replace(/\/$/, '');
  const resolvedUrl =
    typeof url === 'string' && url.startsWith('/') && backendBaseUrl
      ? `${backendBaseUrl}${url}`
      : url;

  if (!filename) filename = String(resolvedUrl).split('\\').pop().split('/').pop();
  const tokenRaw = localStorage.getItem('token');
  const token =
    tokenRaw && tokenRaw.startsWith('"')
      ? (() => {
          try {
            return JSON.parse(tokenRaw);
          } catch {
            return tokenRaw;
          }
        })()
      : tokenRaw;

  fetch(resolvedUrl, {
    headers: new Headers({
      Origin: window.location.origin,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    }),
    mode: 'cors',
    credentials: 'include',
  })
    .then((response) => {
      // Sem esta checagem o corpo de um 401/404 vira blob e o navegador salva um
      // arquivo corrompido com a extensão certa — pior do que não baixar, porque
      // parece que deu certo.
      if (!response.ok) throw new Error(`Download falhou (HTTP ${response.status})`);
      return response.blob();
    })
    .then((blob) => {
      forceDownload(window.URL.createObjectURL(blob), filename);
    })
    .catch(() => {});
}

export const insertNineDigitBrazilianPhoneNumber = (number) => {
  if (number.length === 12) {
    return number.slice(0, 4) + '9' + number.slice(4);
  }
  return number;
};
